<template>
	<div>
		<div class="title-area">
			<div class="back" @click="$router.back()">
				<i class="el-icon-arrow-left"></i>
			</div>
			<div>{{ $t(`text21`) }}</div>
		</div>
		<div class="content-area">
			<div class="content">
				<el-form
					:model="loginForm"
					:rules="rules"
					ref="formRef"
					label-position="left"
					label-width="95px"
				>
					<div class="column-title">{{ $t(`text39`) }}</div>
					<el-form-item :label="$t(`text40`)" prop="ProjectName">
						<el-input
							v-model="loginForm.ProjectName"
							:placeholder="$t(`text8`)"
						></el-input>
					</el-form-item>
					<el-form-item :label="$t(`text26`)" prop="UnitNumber">
						<el-input
							v-model="loginForm.UnitNumber"
							:placeholder="$t(`text8`)"
						></el-input>
						<!-- <el-select
							v-model="loginForm.UnitNumber"
							style="width: 100%;"
							:placeholder="$t(`text34`)"
						>
							<el-option
								v-for="item in unitNumberOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select> -->
					</el-form-item>
					<el-form-item :label="$t(`text41`)" prop="ErrorType">
						<el-select
							v-model="loginForm.ErrorType"
							style="width: 100%;"
							:placeholder="$t(`text34`)"
						>
							<el-option
								v-for="item in errorTypeOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						:label="$t(`text42`)"
						prop="ProjectProvinceID"
					>
						<el-select
							v-model="loginForm.ProjectProvinceID"
							style="width: 100%;"
							:placeholder="$t(`text34`)"
							@change="handleProjectProvince"
						>
							<el-option
								v-for="item in provincesOptions"
								:key="item.value"
								:label="item.lable"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t(`text51`)" prop="CityID">
						<el-select
							v-model="loginForm.CityID"
							style="width: 100%;"
							:placeholder="$t(`text34`)"
						>
							<el-option
								v-for="item in cityOptions"
								:key="item.value"
								:label="item.lable"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t(`text43`)" prop="SalesOrder">
						<el-input
							v-model="loginForm.SalesOrder"
							:placeholder="$t(`text57`)"
						></el-input>
					</el-form-item>
					<!-- <el-form-item :label="$t(`text50`)" prop="QRCode">
						<el-input
							v-model="loginForm.QRCode"
							:placeholder="$t(`text8`)"
							disabled
						></el-input>
					</el-form-item> -->
					<el-form-item
						:label="$t(`text44`)"
						prop="ProblemDescription"
					>
						<el-input
							type="textarea"
							:rows="4"
							:placeholder="$t(`text8`)"
							v-model="loginForm.ProblemDescription"
						>
						</el-input>
					</el-form-item>
					<el-form-item :label="$t(`text45`)" prop="ProblemPicUrl">
						<el-upload
							action="#"
							list-type="picture-card"
							:http-request="handleHttpUpload"
							:on-remove="handleRemove"
							accept=".png,.jpg,.jpeg"
						>
							<i class="el-icon-plus"></i>
						</el-upload>
						<div class="tips">{{ $t(`text58`) }}</div>
					</el-form-item>
					<div class="column-title">{{ $t(`text46`) }}</div>
					<el-form-item
						:label="$t(`text46`)"
						prop="ContactInformation"
					>
						<el-input
							v-model="loginForm.ContactInformation"
							:placeholder="$t(`text8`)"
						></el-input>
					</el-form-item>
					<el-form-item :label="$t(`text47`)" prop="Email">
						<el-input
							v-model="loginForm.Email"
							:placeholder="$t(`text8`)"
						></el-input>
					</el-form-item>
				</el-form>
				<div class="btn-area">
					<el-button
						class="btn"
						type="primary"
						:loading="isLoading"
						@click="submitForm"
					>
						{{ $t(`text48`) }}
					</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	getUnitNumbers,
	getErrorTypes,
	getProvinces,
	getCitiesByProvinceID,
	upload,
	declareAfterSalesOrder,
} from "@/api/qrcode";

export default {
	components: {},
	data() {
		return {
			isLoading: false,
			loginForm: {
				ProjectName: "", //项目名称
				ContactInformation: this.$store.getters.user.PhoneNumber, //联系方式（手机）
				Email: this.$store.getters.user.Email, //电子邮件
				UnitNumber: "", //机组编号
				ErrorType: "", //故障类型
				SalesOrder: "", //销售订单号
				ProblemDescription: "", //问题描述
				ProblemPicUrl: [], //问题图片地址
				ProjectProvinceID: "", //省份ID
				CityID: "", //市ID
				QRCode: sessionStorage.getItem("code"), //二维码ID
			},
			rules: {
				ProjectName: [
					{
						required: true,
						message: this.$t(`text8`),
					},
				],
				ContactInformation: [
					{
						required: true,
						message: this.$t(`text8`),
					},
				],
				UnitNumber: [
					{
						required: true,
						message: this.$t(`text34`),
					},
				],
				ErrorType: [
					{
						required: true,
						message: this.$t(`text34`),
					},
				],
				ProjectProvinceID: [
					{
						required: true,
						message: this.$t(`text34`),
					},
				],
				CityID: [
					{
						required: true,
						message: this.$t(`text34`),
					},
				],
				SalesOrder: [
					{
						required: true,
						message: this.$t(`text8`),
					},
				],
			},
			uploadFileList: [],
			unitNumberOptions: [],
			errorTypeOptions: [],
			provincesOptions: [],
			cityOptions: [],
		};
	},
	mounted() {
		this.getUnitNumbersData();
		this.getErrorTypesData();
		this.getProvincesData();
	},
	methods: {
		submitForm() {
			this.$refs["formRef"].validate(async (valid) => {
				if (valid) {
					this.loginForm.ProblemPicUrl = this.uploadFileList.map(
						(item) => item.url
					);
					this.isLoading = true;
					let { Code } = await declareAfterSalesOrder(this.loginForm);
					if (Code === 200) {
						this.$message({
							message: this.$t(`text56`),
							type: "success",
						});
						setTimeout(() => {
							this.$router.back();
						}, 1000);
					} else {
						this.isLoading = false;
					}
				}
			});
		},
		async handleHttpUpload(options) {
			let formData = new FormData();
			formData.append("file", options.file);
			let { Data } = await upload(formData);
			this.uploadFileList.push(Data);
		},
		handleRemove(file) {
			this.uploadFileList = this.uploadFileList.filter(
				(item) => item.name !== file.name
			);
		},
		async handleProjectProvince(e) {
			let params = {
				provincesID: e,
			};
			let { Data } = await getCitiesByProvinceID(params);
			this.cityOptions = Data;
			this.loginForm.CityID = "";
		},
		async getUnitNumbersData() {
			let { Data } = await getUnitNumbers();
			this.unitNumberOptions = Data;
		},
		async getErrorTypesData() {
			let { Data } = await getErrorTypes();
			this.errorTypeOptions = Data;
		},
		async getProvincesData() {
			let { Data } = await getProvinces();
			this.provincesOptions = Data;
		},
	},
};
</script>

<style scoped lang="scss">
::v-deep .el-upload-list--picture-card .el-upload-list__item,
::v-deep .el-upload--picture-card {
	width: 70px;
	height: 70px;
}
::v-deep .el-upload--picture-card {
	line-height: 80px;
}

.title-area {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 45px;
	font-size: 24px;
	font-size: 0.5rem;
	.back {
		font-size: 24px;
		position: absolute;
		top: 50%;
		left: 5px;
		transform: translateY(-50%);
	}
}
.content-area {
	position: fixed;
	left: 0;
	right: 0;
	top: 45px;
	bottom: 0;
	background-color: #7b8194;
	padding: 10px;
	.content {
		position: absolute;
		inset: 10px;
		padding: 10px;
		background-color: #fff;
		border-radius: 10px;
		overflow-y: auto;
		.column-title {
			padding-bottom: 10px;
			margin-bottom: 15px;
			font-size: 18px;
			color: #135192;
			font-weight: bold;
			border-bottom: 1px solid #e6e6e6;
		}
		.img {
			width: 70px;
			height: 70px;
			object-fit: contain;
		}
		.tips {
			font-size: 12px;
			color: #ccc;
			text-transform: lowercase;
		}
		.btn-area {
			display: flex;
			justify-content: center;
			margin-top: 50px;
			.btn {
				width: 60%;
				margin: 0 auto;
				background-color: #135192;
				border: none;
			}
		}
	}
}
</style>
